import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../utils/constants';
import { useAuth } from '../contexts/AuthContext';

function SupportPage() {
  const { isAuthenticated } = useAuth();

  return (
    <div className="page">
      <div className="container">
        <div className="content-page">
          <h1>Support QDN</h1>

          <section className="content-section">
            <p>
              QDN is a small, community-run project, not an ad-driven platform. Support helps keep the lights on and, over time, 
              makes it possible to resource community members who do care work around queer data.
            </p>
          </section>

          <section className="content-section">
            <h2>What Support Covers</h2>
            <p>Financial support may help cover:</p>
            <ul>
              <li>Hosting, domain, and infrastructure costs.</li>
              <li>Moderation and community care work, including time spent responding to reports and improving safety features.</li>
              <li>Design, accessibility work, and future features that the community requests.</li>
              <li>
                Longer-term goals like compensating contributors for substantial resources, especially when they share lived experience 
                or do translation, editing, or accessibility work.
              </li>
            </ul>
            <p>
              QDN will be transparent about how funds are used and will avoid any funding arrangements that compromise community safety 
              or turn the space into a data-extraction project.
            </p>
          </section>

          <section className="content-section">
            <h2>How to Give Financial Support</h2>
            <p>
              Right now, the simplest way to support QDN financially is through a one-time donation using the "Support QDN" button, 
              which processes payments via Stripe. Ongoing memberships or other options may be added later if there is interest and capacity.
            </p>
            <p>
              <strong>No one is required to pay to participate.</strong> If contributing financially would cause strain, your presence 
              and insights are already a meaningful contribution.
            </p>
            
            <div className="cta-section">
              <a 
                href="https://donate.stripe.com/test_placeholder" 
                className="btn btn-primary"
                target="_blank"
                rel="noreferrer"
              >
                Support via Stripe
              </a>
            </div>
          </section>

          <section className="content-section">
            <h2>Non-Financial Ways to Help</h2>
            <p>Non-financial support is just as important:</p>
            <ul>
              <li>
                <strong>Write or share resources:</strong> guides, reflections, case studies, or curated lists that others might find useful.
              </li>
              <li>
                <strong>Invite others:</strong> tell queer friends, colleagues, classmates, or organizers in data/tech spaces who might want to join.
              </li>
              <li>
                <strong>Offer feedback:</strong> suggest features, content areas, or moderation practices that would make the space safer 
                and more sustainable.
              </li>
              <li>
                <strong>Help with review:</strong> if you have experience in ethics, security, accessibility, or community moderation, 
                you can volunteer time to review content or processes.
              </li>
            </ul>
          </section>

          <section className="content-section cta-section">
            {!isAuthenticated ? (
              <Link to={ROUTES.REGISTER} className="btn btn-primary">
                Join QDN
              </Link>
            ) : (
              <Link to={ROUTES.CONTENT} className="btn btn-primary">
                Browse Resources
              </Link>
            )}
            <Link to={ROUTES.CONTACT} className="btn btn-outline">
              Contact Us
            </Link>
          </section>
        </div>
      </div>
    </div>
  );
}

export default SupportPage;
